import { useCallback, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ConfirmModal from "./ConfirmModal";
import { removeDismissedPendingOrders, removeSession } from "@/utils";
import { removeUserData } from "@/store/userData/userDataSlice";
import { HomePage } from "@/routes/RoutesPath";

const noop = () => {};

const LogoutConfirm = ({
  isOpen,
  onConfirm = noop,               
  onCancel = noop,
  navigateTo = HomePage,  
}) => {
  const websiteColor = useSelector((state) => state?.onLoadData?.color);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogoutConfirm = useCallback(() => {
    removeSession();
    dispatch(removeUserData());
    removeDismissedPendingOrders();
    navigate(navigateTo);
    onConfirm();
  }, [dispatch, navigate, navigateTo, onConfirm]);

  return (
    <ConfirmModal
      isOpen={isOpen}
      onConfirm={handleLogoutConfirm}
      onCancel={onCancel}
      avatarAlt="User avatar"
      title="Are you sure you want to log out?"
      message=""
      confirmLabel="Logout"
      cancelLabel="Cancel"
      confirmButtonStyle={{ backgroundColor: websiteColor }}
    />
  );
};

const LogoutConfirmModal = memo(LogoutConfirm);

export default LogoutConfirmModal;
